export default __webpack_public_path__ + "static/media/logo-light.e3f9fdcc.png";